import React, { createContext, useContext } from 'react'
import { AbilityBuilder, Ability } from '@casl/ability'
import { CurrentUserContext } from './currentUserContext'
import IPermission from '../interfaces/Permission'

export const AbilityContext = createContext({} as any)

const AbilityContextProvider = (props: any) => {
  const currentUser = useContext(CurrentUserContext)
  const { can, rules } = new AbilityBuilder(Ability)

  if (currentUser) {
    currentUser.permissions.forEach((permission: IPermission) => {
      can(permission.action, permission.model)
    })
  }

  const ability = new Ability(rules)

  return (
    <AbilityContext.Provider value={ability}>
      {props.children}
    </AbilityContext.Provider>
  )
}

export default AbilityContextProvider
